import { api } from 'lib/axios'
import { getUserId } from 'lib/auth/tokenStorage'

export const getUser = async () => {
  const agent_id = getUserId()
  if (!agent_id) {
    throw new Error('Missing agent_id')
  }

  const response = await api.post(
    '/Api/V8/custom/portal/get-agent-profile-page-data',
    {
      agent_id
    }
  )
  return response.data
}
